import {useState} from 'react';
import {useI18n} from '../locales/I18n';
import {privacyChoices,privacyUnavailable} from '../../shared/ad-privacy';
import {ensureAdPrivacy} from './adsense-runtime';
import {adsenseConfig} from './adsense-config';
export function PrivacyChoices(){
 const {t}=useI18n(),[message,setMessage]=useState(''),[busy,setBusy]=useState(false);
 async function open(){setBusy(true);try{setMessage(adsenseConfig.serving&&await ensureAdPrivacy(adsenseConfig.publisher)?'':privacyUnavailable);}catch{setMessage(privacyUnavailable);}finally{setBusy(false);}}
 return <div><button type="button" className="outline-button ad-privacy-button" disabled={busy} onClick={()=>void open()}>{t(busy?'Please wait.':privacyChoices)}</button>{message&&<p role="status">{t(message)}</p>}</div>;
}
